/* eslint-disable indent */
import React, {
  useEffect, useState, Fragment, useMemo,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Drawer, Tooltip, Popconfirm, notification, Dropdown, Checkbox, Select, Rate, Button, Menu,
  Tag,
  Divider,
} from 'antd';
import {
  ControlOutlined, FilterOutlined,
  EditOutlined, LoadingOutlined, MailOutlined, PhoneOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import SellerActions from '@Actions/sellerActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantActions from '@Actions/tenantActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import VendorForm from '@Components/Common/VendorForm';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import BulkImportSellers from './BulkImportVendors';
import AdvanceFilter from '../../../Common/AdvanceFilter';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './helpers';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import {
  toISTDate, CountryCodes, entityNameEnum, filterTypeEnums, getLicenseKey
} from '@Apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

/**
 *
 */
function VendorsList({
  sellers, getSellersLoading, user, getSellers, history, getDocCFV2Success, syncVendorLoading,
  pullVendors, pullVendorsLoading, getTenants, syncVendor, getDocCFV2, getDocCFV2Loading, customFieldsProps,
  MONEY,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showNewVendorModal, setShowNewVendorModal] = useState(false);
  const [showUpdateVendorModal, setShowUpdateVendorModal] = useState(false);
  const [bulkUploadSellers, setBulkUploadSellers] = useState(true);
  const [showBulkImportDrawer, setShowBulkImportDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(false);
  const [vendorTypes, setVendorTypes] = useState([]);
  const [fixedColumns, setFixedColumns] = useState(['VENDOR_NAME']);
  const [visible, setVisible] = useState(false);
  const [openAdvanceProductFiltersDrawer, setOpenAdvanceProductFiltersDrawer] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState('');
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-vendors') ? JSON.parse(localStorage.getItem('prcz-page-columns-vendors')) : {
    VENDOR_NAME: {
      label: 'Vendor Name',
      visible: true,
    },
    VENDOR_TYPE: {
      label: 'Vendor Type',
      visible: true,
    },
    INTERNAL_SLR_CODE: {
      label: 'Seller Code',
      visible: true,
    },
    EMAIL: {
      label: 'Email',
      visible: true,
    },
    CONTACT_NUMBER: {
      label: 'Contact Number',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    PRODUCTS: {
      label: 'Products',
      visible: true,
    },
    PAYMENT_TERMS: {
      label: 'Payment Terms',
      visible: true,
    },
    LINKED_CUSTOMER: {
      label: 'Linked Customer',
      visible: true,
    },
    // PAYABLE: {
    //   label: 'Payable',
    //   visible: true,
    // },
    // UNUSED_CREDITS: {
    //   label: 'Unused Credits',
    //   visible: true,
    // },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    BANK_ACCOUNT_NO: {
      label: 'Bank Account Number',
      visible: false,
    },
    BANK_IFSC: {
      label: 'Bank IFSC',
      visible: true,
    },
  });

  //save filter states
  const [currentDefaultView, setCurrentDefaultView] = useState(null);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const customFieldOptions = useMemo(() => {
    if (customFieldsProps) {
      const data = { customFields: [...customFieldsProps?.data?.document_custom_fields, ...customFieldsProps?.data?.document_line_custom_fields] };
      const fieldOptions = data?.customFields?.filter((item) => item.is_active);
      return fieldOptions;
    }
  }, [customFieldsProps]);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const onMenuClick = (e) => {
    if (e.key === '1' || e.key === 1) {
      setShowBulkImportDrawer(true);
      setBulkUploadSellers(true);
    } else if (e.key === '2' || e.key === 2) {
      setShowBulkImportDrawer(true);
      setBulkUploadSellers(false);
    }
  };
  const items = [
    {
      key: '1',
      label: 'Upload New Vendors',
    },
    {
      key: '2',
      label: 'Update Existing Vendors',
    },
  ];

  const getVendorColumns = () => {
    const vendorListColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/vendors/view/${record.seller_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <div>
      //             <div
      //               style={{
      //                 fontWeight: '600', fontSize: '12px', cursor: 'pointer',
      //               }}
      //             >
      //               {record.seller_info ? `${record.seller_info?.seller_name}` : ''}
      //             </div>
      //             {record?.seller_info?.manufacturing_address_details?.city && (
      //               <div>
      //                 {record?.seller_info?.manufacturing_address_details?.city || ''}
      //               </div>
      //             )}
      //           </div>
      //           <div className={`mobile-list__item-status ${record?.is_active ? 'status-tag' : 'status-tag__inactive'}`}>
      //             {record?.is_active ? 'Active' : 'Inactive'}
      //             {' '}
      //           </div>
      //         </div>
      //         {record?.seller_info?.email_id_1 && (
      //           <div className="mobile-list__item-info">
      //             <div><MailOutlined /></div>
      //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>{record?.seller_info?.email_id_1 || '-'}</div>
      //           </div>
      //         )}
      //         {record?.seller_info?.mobile_1 && (
      //           <div className="mobile-list__item-info">
      //             <div><PhoneOutlined /></div>
      //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>{record?.seller_info?.mobile_1 || '-'}</div>
      //           </div>
      //         )}
      //         <H3Text
      //           text={`Payable - ${MONEY(Number(record?.outgoing_payable || '0'))}`}
      //           className="mobile-list__item-info"
      //         />
      //         <H3Text
      //           text={`Unused Credits - ${MONEY(Number(record?.unused_credits || '0'))}`}
      //           className="mobile-list__item-info"
      //         />
      //         <div className="vendor-mobile-list__item-footer">
      //           <div />
      //           <div className="mobile-list__item-footer-right" style={{}}>
      //             {
      //               user?.tenant_info?.zoho_branch_id && (
      //                 user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id
      //                 && (
      //                   <div>
      //                     {(record?.zoho_seller_id)
      //                       ? (
      //                         <Tooltip
      //                           title={`Last Sync ${toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}`}
      //                           overlayClassName="font-12"
      //                           placement="topRight"
      //                         >
      //                           <a href={`https://books.zoho.in/app#/vendors/${record?.zoho_seller_id}`} target="_blank" rel="noreferrer">
      //                             <div className="img-zoho_vendor-book-wrapper">
      //                               <img
      //                                 src={ZohoBooks}
      //                                 alt="Zoho"
      //                                 className="img-zoho_vendor-book"
      //                               />
      //                               <div className="green-indicator" />
      //                             </div>
      //                           </a>
      //                         </Tooltip>
      //                       )
      //                       : (
      //                         <div>
      //                           <Popconfirm
      //                             placement="topRight"
      //                             title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Vendor is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
      //                             onConfirm={() => syncVendor(
      //                               { seller_id: record?.seller_id },
      //                               () => getSellers('', user?.tenant_info?.tenant_id, currentPage, 10, '', () => { }, true),
      //                             )}
      //                             okText="Sync again"
      //                             okButtonProps={{
      //                               loading: syncVendorLoading,
      //                             }}
      //                             cancelText="Cancel"
      //                           >
      //                             <div className="img-zoho_vendor-book-wrapper">
      //                               <img
      //                                 src={ZohoBooks}
      //                                 alt="Zoho"
      //                                 className="img-zoho_vendor-book img-zoho_vendor-book-disabled"
      //                               />
      //                               <div className="green-indicator red-indicator" />
      //                             </div>
      //                           </Popconfirm>
      //                         </div>
      //                       )}
      //                   </div>
      //                 )
      //               )
      //             }
      //           </div>
      //         </div>
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link>
                  <PRZText
                    text={`#${record?.seller_info?.internal_slr_code || '-'}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  text={record?.is_active ? 'Active' : 'Inactive'}
                  className={`mobile-list__card__status ${record?.is_active ? 'status-tag__active' : 'status-tag__inactive'}`}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Link>
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={record.seller_info?.seller_name?.trim() || '-'}
                    />
                  </Link>
                </div>

                {record?.seller_info?.email_id_1 && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Email: ${record?.seller_info?.email_id_1}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText
                      text={`Email: ${record?.seller_info?.email_id_1}`}
                      className="mobile-list__card_item-details"
                    />
                  </Tooltip>
                )}

                {record?.seller_info?.mobile_1 && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Phone: ${record?.seller_info?.mobile_1}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText
                      text={`Phone: ${record?.seller_info?.mobile_1}`}
                      className="mobile-list__card_item-details"
                    />
                  </Tooltip>
                )}
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Payment Terms" />
                  )}
                >
                  <PRZText
                    text={!record?.seller_info?.default_payment_terms?.due_days ? 'On Delivery' : `${record?.seller_info?.default_payment_terms?.due_days} Days Credit`}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <div className="mobile-list__card_footer__actions-button_wrapper">
                  {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id
                    && (
                      <div className="card_footer__actions-button">
                        {(record?.zoho_seller_id)
                          ? (
                            <Tooltip
                              title={`Last Sync ${toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                              overlayClassName="font-12"
                              placement="topRight"
                            >
                              <a
                                href={`https://books.zoho.in/app#/vendors/${record?.zoho_seller_id}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                  <img
                                    style={{
                                      width: '18px',
                                      height: '18px',
                                    }}
                                    src={ZohoBooks}
                                    alt="Zoho"
                                    className="img-zoho card_footer__actions-button_image"
                                  />
                                  <div className="green-indicator" />
                                </div>
                              </a>
                            </Tooltip>
                          )
                          : (
                            <Popconfirm
                              title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Vendor is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                              onConfirm={() => syncVendor(
                                { seller_id: record?.seller_id },
                                () => getSellers('', user?.tenant_info?.tenant_id, currentPage, 10, '', () => {
                                }, true),
                              )}
                              okText="Sync again"
                              okButtonProps={{
                                loading: syncVendorLoading,
                              }}
                              cancelText="Cancel"
                            >
                              <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  style={{
                                    width: '18px',
                                    height: '18px',
                                  }}
                                  src={ZohoBooks}
                                  alt="Zoho"
                                  className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                />
                                <div className="green-indicator red-indicator" />
                              </div>
                            </Popconfirm>
                          )}
                      </div>
                    )}
                </div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedVendor(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'VENDOR #',
        fixed: 'left',
        render: (text, record) => {
          function getRatingColor(rating) {
            if (rating >= 3) {
              return 'green';
            } if (rating >= 2) {
              return 'yellow';
            }
            return 'red';
          }
          return (
            <div className="min-width-85">
              {record?.seller_info?.internal_slr_code || '-'}
              {user?.tenant_info?.seller_rating_config?.is_active && record?.rating > 0 && (
                <div className={`vendor-table-rating-container ${getRatingColor(record?.rating)}`}>
                  <div className="rating-container-main">
                    <span className="rating-value">{record?.rating?.toFixed(1)}</span>
                    <span className="rating-star">&#9733;</span>
                  </div>
                </div>
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.INTERNAL_SLR_CODE.visible ? 'display-none' : '',
      },
      {
        title: 'NAME',
        key: 'name',
        render: (text, record) => (
          <div className="min-width-50">
            <div>
              {`${record?.seller_info?.seller_name} ${record?.seller_info?.office_address_details?.city ? `(${record?.seller_info?.office_address_details?.city})` : ''}`}
            </div>
            <div className="flex-display" style={{ marginBottom: '5px' }}>
              {record?.seller_info?.is_marketplace_seller && (
                <div>
                  <H3Text text="Marketplace" className="marketplace-status-tag" />
                </div>
              )}
              {record?.seller_info?.is_subcontractor && (
                <div>
                  <H3Text text="Subcontractor" className="subcontractor-status-tag" />
                </div>
              )}
              {record?.is_transporter && (
                <div>
                  <H3Text text="Transporter" className="transporter-status-tag" />
                </div>
              )}
            </div>
            <div />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.VENDOR_NAME.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'VENDOR TYPE',
        render: (text, record) => (
          <div className="min-width-50">
            {record?.seller_info?.seller_type?.toProperCase() ?? '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.VENDOR_TYPE.visible ? 'display-none' : '',
      },
      {
        title: 'EMAIL',
        render: (text, record) => (
          // eslint-disable-next-line react/jsx-filename-extension
          <div className="min-width-50">
            {record?.seller_info?.email_id_1 ? record?.seller_info?.email_id_1 : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.EMAIL.visible ? 'display-none' : '',
      },
      {
        title: 'CONTACT NUMBER',
        render: (text, record) => (
          <div className="min-width-130">
            {record?.seller_info?.mobile_1 ? (`${CountryCodes?.find((code) => code?.dial_code == record?.seller_info?.dial_code)?.flag} +${record?.seller_info?.dial_code} ${record?.seller_info?.mobile_1}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.CONTACT_NUMBER.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (text, record) => (
          <div className="min-width-70">
            <H3Text text={record?.is_active ? 'Active' : 'Inactive'} className={record?.is_active ? 'status-tag' : 'status-tag__inactive'} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.STATUS.visible ? 'display-none' : '',
      },
      {
        title: 'PRODUCTS',
        render: (text, record) => (
          <div className="min-width-70">
            {record.seller_product_count ? record.seller_product_count : 0}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.PRODUCTS.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT TERMS',
        render: (text, record) => (
          <div className="min-width-115">
            {!record?.seller_info?.default_payment_terms?.due_days ? 'On Delivery' : `${record?.seller_info?.default_payment_terms?.due_days} Days Credit`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_TERMS?.visible ? 'display-none' : '',
      },
      {
        title: 'LINKED CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-130">
            <Link to={`/sales/customer/view/${record?.seller_info?.customer_id}`} target="_blank">{record?.seller_info?.customer_name}</Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LINKED_CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="column-date min-width-115">
            {toISTDate(record?.seller_info?.created_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'BANK ACC #',
        render: (text, record) => (
          <div className="min-width-100">
            {record?.seller_info?.bank_account_no}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BANK_ACCOUNT_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'BANK IFSC #',
        render: (text, record) => (
          <div className="min-width-100">
            {record?.seller_info?.bank_ifsc}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BANK_IFSC?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        vendorListColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    vendorListColumns.push({
      title: '',
      key: 'action',
      render: (text, record) => (
        <div className="list__actions">
          {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id
            && (
              <div className="list__actions-button">
                {(record?.zoho_seller_id)
                  ? (
                    <Tooltip
                      title={`Last Sync ${toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                      overlayClassName="font-12"
                      placement="topRight"
                    >
                      <a
                        href={`https://books.zoho.in/app#/vendors/${record?.zoho_seller_id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="img-zoho__wrapper">
                          <img
                            src={ZohoBooks}
                            alt="Zoho"
                            className="img-zoho"
                          />
                          <div className="green-indicator" />
                        </div>
                      </a>
                    </Tooltip>
                  )
                  : (
                    <Popconfirm
                      placement="topRight"
                      title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Vendor is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                      onConfirm={() => syncVendor(
                        { seller_id: record?.seller_id },
                        () => getSellers('', user?.tenant_info?.tenant_id, currentPage, 10, '', () => {
                        }, true),
                      )}
                      okText="Sync again"
                      okButtonProps={{
                        loading: syncVendorLoading,
                      }}
                      cancelText="Cancel"
                    >
                      <div className="img-zoho__wrapper">
                        <img
                          src={ZohoBooks}
                          alt="Zoho"
                          className="img-zoho img-zoho__disabled"
                        />
                        <div className="green-indicator red-indicator" />
                      </div>
                    </Popconfirm>
                  )}
              </div>
            )}
          {/* {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
            Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="list__actions-button"
                onClick={() => {
                  getDocCFV2Success(null);
                  setSelectedSeller(record);
                  setShowUpdateVendorModal(true);
                }}
              >
                <EditOutlined />
              </div>
            )} */}
          {!isPortrait && (
            <div className="list__actions-button list__actions-button-dark" onClick={() => history.push(`/vendors/view/${record.seller_id}`)}>
              View
            </div>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      fixed: 'right',
      className: 'list__actions-column',
    });
    return vendorListColumns.filter((item) => !item.hidden);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }
  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'vendorTypes',
        filter_value: Helpers.getValueFromUrl('vendorTypes') ? Helpers.getValueFromUrl('vendorTypes')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'advance_filter',
        filter_value: Helpers.getValueFromUrl('advance_filter') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'vendorTypes',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'advance_filter',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.VENDORS,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setVendorTypes(tempFilterValues.vendorTypes);
        setAdvanceFilters(tempFilterValues.advance_filter);
        setShowNewVendorModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const pushParamsToUrl = (page, limit, word, currentVendorTypes, advanceFilters, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (currentVendorTypes) url += `&vendorTypes=${currentVendorTypes}`;
    if (advanceFilters) url += `&advance_filter=${advanceFilters}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-vendors'))?.[customField.cf_id]?.visible || false,

        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setIsUserReady(true);
      // setVendorTypes(Helpers.getValueFromUrl('vendorTypes') ? Helpers.getValueFromUrl('vendorTypes')?.split(',')?.map((item) => item) : []);
      // setShowNewVendorModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
      // setAdvanceFilters(Helpers.getValueFromUrl('advance_filter'));
      setSelectedFilterView(systemDefaultUserView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
    }
  }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, vendorTypes, advanceFilters, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getTenants(1, '', true, user?.tenant_info?.org_id, 100, () => { });
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'VENDORS',
      };
      getDocCFV2(payload);
      getSellers(Helpers.getValueFromUrl('keyword'), user?.tenant_info?.tenant_id, Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', () => { }, true, null, Helpers.getValueFromUrl('vendorTypes'), null, null, null, Helpers.getValueFromUrl('advance_filter'));
    }
  }, [limit, searchKeyword, currentPage, limit, vendorTypes, call, advanceFilters]);

  const vendorTypeOptions = [
    { key: 'TRANSPORTER', value: 'TRANSPORTER', label: 'Transporter' },
    ...(user?.tenant_info?.global_config?.settings?.marketplace_enabled
      ? [{ key: 'MARKETPLACE', value: 'MARKETPLACE', label: 'Marketplace' }]
      : []),
    { key: 'SUB_CONTRACTOR', value: 'SUB_CONTRACTOR', label: 'Subcontractor' },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for vendors name.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right vendors__header__buttons">
                {user?.tenant_info?.zoho_branch_id && (
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_BORDERED}
                    text={(
                      <React.Fragment>
                        {!pullVendorsLoading ? (
                          <div className="flex-align-c">
                            <H3Image src={ZohoBooks} className="vendors__header__zoho-icon hide__in-mobile" />
                            <H3Text text="Sync" className="action-menu-button" />
                          </div>
                        )
                          : <LoadingOutlined />}
                      </React.Fragment>
                    )}
                    onClick={() => pullVendors(
                      { org_id: user?.tenant_info?.org_id, per_page: 10000 },
                      () => {
                        getSellers(keyword, user?.tenant_info?.tenant_id, currentPage, 10, '', () => { }, true);
                      },
                    )}
                    customClass="vendors__header__zoho-button hide__in-mobile"
                  />
                )}
                {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <Button
                        type="primary"
                        onClick={() => {
                          setShowNewVendorModal(true);
                          getDocCFV2Success(null);
                        }}
                      >
                        + Add Vendor
                      </Button>
                      <Dropdown
                        overlay={<Menu items={items} onClick={onMenuClick} />}
                        trigger={['hover']}
                        open={visible}
                        onOpenChange={handleVisibleChange}
                      >
                        <Button type="primary"> + Upload Vendors</Button>
                      </Dropdown>
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;

                    setCurrentPage(1);
                    setKeyword(tempFilterValues.keyword);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setAdvanceFilters(tempFilterValues.advance_filter);
                    setVendorTypes(tempFilterValues.vendorTypes);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.VENDORS}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {vendorTypes && vendorTypes?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setVendorTypes(vendorTypes?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Vendor Type -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()?.replace('_', ' ')}</b>
                    </span>
                  </Tag>
                ))}
                {advanceFilters?.length > 0 && (
                  <Tag closable onClose={() => { setAdvanceFilters(''); setCurrentPage(1); }} color="#2d7df7">
                    Advanced Filters
                  </Tag>
                )}
              </div>
            </div>
            {searchKeyword && searchKeyword.length > 0 && (
              <div className="search-bar__search-container__clear-button">
                <H3Text
                  text={(
                    <React.Fragment>
                      Showing search results for&nbsp;
                      <i>
                        <b>
                          {`'${searchKeyword}'`}
                        </b>
                      </i>
                    </React.Fragment>
                  )}
                  className="section-search-keyword"
                />
                <H3Text
                  text="clear"
                  className="search-bar__clear-button"
                  onClick={() => {
                    setSearchKeyword('');
                    setKeyword('');
                    setCurrentPage(1);
                  }}
                />
              </div>
            )}

            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(sellers && sellers.count) ? sellers.count : '0'} Registered Vendors`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div
                                className="filter__container filter__container-section"
                              >
                                <div className="filter__title"> Vendor Type </div>
                                <PRZSelect
                                  mode="multiple"
                                  maxTagCount="responsive"
                                  filterOption={false}
                                  value={vendorTypes}
                                  allowClear
                                  onChange={(value) => {
                                    const vendorTypeList = [];

                                    for (let i = 0; i < value?.length; i++) {
                                      vendorTypeList.push(value[i]);
                                    }
                                    setVendorTypes(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Vendor Types"
                                  options={vendorTypeOptions}
                                />
                              </div>
                              <div className="filter__container-wrapper-vendor">
                                <div className="advanced-filter__container" onClick={() => setOpenAdvanceProductFiltersDrawer(true)}>
                                  <H3Text
                                    text={(
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Advanced Filter
                                        {/* &nbsp;
                                        <span className="new__tag">New</span> */}
                                      </div>
                                    )}
                                    className="action-button-text"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-vendors', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-vendors', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                loading={getSellersLoading || syncVendorLoading || getDocCFV2Loading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && sellers && !!sellers.sellers?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && sellers && !!sellers.sellers?.length}
                columns={getVendorColumns()}
                dataSource={sellers && sellers.sellers ? sellers.sellers : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: sellers ? sellers.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewVendorModal}
        onClose={() => setShowNewVendorModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Add New Vendor" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewVendorModal(false)} />
          </div>
        </div>
        <VendorForm
          callback={() => {
            getSellers('', user?.tenant_info?.tenant_id, currentPage, 10, '', () => { }, true);
            setShowNewVendorModal(false);
          }}
        />
      </Drawer>
      <Drawer
        title="Update Vendor Information"
        open={showUpdateVendorModal}
        onClose={() => setShowUpdateVendorModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Update Vendor Information" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateVendorModal(false)} />
          </div>
        </div>
        <VendorForm
          selectedSeller={selectedSeller}
          callback={() => {
            getSellers('', user?.tenant_info?.tenant_id, currentPage, 10, '', () => { }, true);
            setShowUpdateVendorModal(false);
          }}
        />
      </Drawer>
      <Drawer
        placement="right"
        onClose={() => setShowBulkImportDrawer(false)}
        open={showBulkImportDrawer}
        width="745px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '700px' }}>
            <H3Text text={bulkUploadSellers ? 'Import Vendors' : 'Update Vendors'} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkImportDrawer(false)} />
          </div>
        </div>
        <BulkImportSellers
          isBulkUploadSellers={bulkUploadSellers}
          callback={() => {
            setShowBulkImportDrawer(false);
            setCall(!call);
          }}

        />
      </Drawer>
      <Drawer
        open={openAdvanceProductFiltersDrawer}
        width="820px"
        mask
        onClose={() => setOpenAdvanceProductFiltersDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '770px' }}>
            <H3Text text="Apply Advanced Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenAdvanceProductFiltersDrawer(false)} />
          </div>
        </div>
        <AdvanceFilter
          customFieldOptions={customFieldOptions}
          advanceFilters={advanceFilters}
          setAdvanceFilters={setAdvanceFilters}
          setOpenAdvanceProductFiltersDrawer={setOpenAdvanceProductFiltersDrawer}
          customKey="prz-advance-filter-vendor"
        />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedVendor?.seller_info?.seller_name} - ${selectedVendor?.seller_info?.internal_slr_code}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedVendor?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedVendor, MONEY })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, SellerReducers, ZohoIntegrationReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
  syncVendorLoading: ZohoIntegrationReducers.syncVendorLoading,
  pullVendorsLoading: ZohoIntegrationReducers.pullVendorsLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocVendors,
});

const mapDispatchToProps = (dispatch) => ({
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds, advanceFilters) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds, advanceFilters)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback)),
  syncVendor: (payload, callback) => dispatch(ZohoIntegrationActions.syncVendor(payload, callback)),
  pullVendors: (payload, callback) => dispatch(ZohoIntegrationActions.pullVendors(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorsList));
